import { TranslateService } from '@ngx-translate/core';

/**
 * Título de un item de menú en el idioma activo.
 *
 * `translate` puede traer dos cosas:
 * - Versión anterior: una clave i18n (p. ej. `MENU.PAGES.HOME`), que se
 *   traduce al idioma activo, sea cual sea.
 * - Menús de la base: el texto en inglés (titleEnglish), con `title` en
 *   español — mismo criterio que `getNavLabel` en home-header.
 * Se distingue porque una clave existente devuelve un valor distinto de sí
 * misma; un texto libre vuelve igual.
 */
export function getMenuLabel(item: { translate?: string; title?: string }, translateService: TranslateService): string {
  const { translate, title } = item;

  if (translate && translate.includes('.')) {
    const translated = translateService.instant(translate);
    if (translated && translated !== translate) return translated;
  }

  const lang = translateService.currentLang || translateService.defaultLang;
  if (lang === 'en') return translate || title;
  return title;
}
